import axios from './config';

const list = successCb => {
  axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/images`,
  ).then(
    res => successCb(res.data),
  ).catch(
    err => console.error('api.images.list() received error from api request:', err),
  );
};

const get = (id, successCb) => {
  axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/image/${id}`,
  ).then(
    res => successCb(res.data),
  ).catch(
    err => console.error('api.images.get() received error from api request:', err),
  );
};

const post = (params, successCb, errorCb) => {
  axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/image`,
    params,
  ).then(
    res => successCb(res.data),
  ).catch(
    errorCb,
  );
};

const postUrl = (params, successCb, errorCb) => {
  axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/image/from-url`,
    params,
  ).then(
    res => successCb(res.data),
  ).catch(
    errorCb,
  );
};

// const put = (params, successCb, errorCb) => {
//   let { image } = params;

//   axios.put(
//     `${process.env.REACT_APP_API_BASE_URL}/image/${params.id}`,
//     image,
//   ).then(
//     res => successCb(res.data),
//   ).catch(
//     errorCb,
//   );
// };

const endpoints = {
  list,
  get,
  post,
  postUrl,
  // put,
};

export default endpoints;
